module.exports = __webpack_public_path__ + "static/media/welcome@3x.846aa7fe.png";